import { ref, vShow, watch } from 'vue'
export const useMixins = () => {
	const showPassword = ref(true)
	var validatePhone = (rule, value, callback) => {
		const reg = /^[1][3-9][0-9]{9}$/
		if (value == '' || value == undefined || value == null) {
			callback()
		} else {
			if (!reg.test(value) && value != '') {
				callback(new Error('请输入正确的电话号码'))
			} else {
				callback()
			}
		}
	}
	var validateIdCard = (rule, value, callback) => {
		const reg =
			/^[1-9]\d{5}(18|19|20|(\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
		if (value == '' || value == undefined || value == null) {
			callback()
		} else {
			if (!reg.test(value) && value != '') {
				callback(new Error('请输入正确的身份证号'))
			} else {
				callback()
			}
		}
	}
	var validatePassWord = (rule, value, callback) => {
		const reg = /^[A-Za-z\d$@$!%*?&]{6,18}$/
		if (value == '' || value == undefined || value == null) {
			callback()
		} else {
			if (!reg.test(value) && value != '') {
				callback(new Error('不能低于6位高于18位,且仅能为数字、字母、字符'))
			} else {
				callback()
			}
		}
	}
	var validateEmail = (rule, value, callback) => {
		const reg = /^[a-zA-Z0-9]+@[a-zA-Z0-9]+(\.[a-zA-Z]+)+$/
		if (value == '' || value == undefined || value == null) {
			callback()
		} else {
			if (!reg.test(value) && value != '') {
				callback(new Error('请输入正确的邮箱'))
			} else {
				callback()
			}
		}
	}

	let sexList = [
		{
			value: 1,
			label: '男'
		},
		{
			value: 2,
			label: '女'
		}
	]
	let degreeList = [
		{
			value: 0,
			label: '未知'
		},
		{
			value: 5,
			label: '小学'
		},
		{
			value: 10,
			label: '初中'
		},
		{
			value: 15,
			label: '高中'
		},
		{
			value: 20,
			label: '中专'
		},
		{
			value: 25,
			label: '大专'
		},
		{
			value: 30,
			label: '本科'
		},
		{
			value: 35,
			label: '研究生'
		},
		{
			value: 40,
			label: '博士'
		}
	]
	let maritalStatusList = [
		{
			value: 0,
			label: '未婚'
		},
		{
			value: 1,
			label: '已婚'
		}
	]
	let formProps = ref([
		{
			label: '头像', // 图片'
			prop: 'pic_l',
			type: 'image',
			width: '100%',
			multiple: false
		},
		{
			label: '姓名',
			prop: 'name',
			type: 'input',
			placeholder: '请输入',
			width: '100%'
		},
		{
			label: '性别',
			prop: 'sex',
			type: 'select',
			width: '100%',
			options: sexList
		},
		{
			label: '生日',
			prop: 'birthday',
			types: 'date',
			formatValue: 'YYYY-MM-DD',
			formatLabel: 'YYYY-MM-DD',
			type: 'datetimerange',
			placeholder: '请选择',
			width: '100%'
		},
		{
			label: '手机号',
			prop: 'mobile_phone',
			type: 'input',
			placeholder: '请输入',
			width: '100%'
		},
		{
			label: '身份证号',
			prop: 'idcard',
			type: 'input',
			placeholder: '请输入',
			width: '100%'
		},
		{
			label: '邮箱',
			prop: 'email',
			type: 'input',
			placeholder: '请输入',
			width: '100%'
		},
		{
			label: '学历',
			prop: 'degree',
			type: 'select',
			width: '100%',
			options: degreeList
		},
		{
			label: '婚姻状态',
			prop: 'marital_status',
			type: 'select',
			width: '100%',
			options: maritalStatusList
		},
		{
			label: '身高',
			prop: 'height',
			type: 'input',
			placeholder: '请输入',
			width: '100%'
		},
		{
			label: '体重',
			prop: 'weight',
			type: 'input',
			placeholder: '请输入',
			width: '100%'
		},
		{
			label: '家庭住址',
			prop: 'family_address',
			type: 'input',
			placeholder: '请输入',
			width: '100%'
		},
		{
			label: '毕业院校',
			prop: 'school',
			type: 'input',
			placeholder: '请输入',
			width: '100%'
		},
		{
			label: '行政区域编码',
			prop: 'region_code',
			type: 'input',
			placeholder: '请输入',
			width: '100%'
		},
		{
			label: '密码',
			prop: 'password2',
			isShow: showPassword,
			type: 'input',
			placeholder: '请输入',
			width: '100%'
		},
		{
			label: '个人微信', // 图片'
			prop: 'pic_w',
			type: 'image',
			width: '100%',
			multiple: false
		},
		{
			label: 'APP推广码', // 图片'
			prop: 'promote_url',
			type: 'input',
			width: '100%'
		},
		{
			label: 'ima客户端ID', // 图片'
			prop: 'client_id',
			type: 'password',
			width: '100%'
		},
		{
			label: 'ima密钥', // 图片'
			prop: 'api_key',
			type: 'password',
			width: '100%'
		}
	])
	let rules = {
		pic_l: [{ required: true, message: '请选择头像', trigger: 'blur' }],
		name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
		sex: [{ required: true, message: '请选择性别', trigger: 'blur' }],
		mobile_phone: [
			{ required: true, message: '请输入手机号', trigger: 'blur' },
			{ validator: validatePhone, trigger: 'blur' }
		],
		idcard: [
			{ required: true, message: '请输入身份证号', trigger: 'blur' },
			{ validator: validateIdCard, trigger: 'blur' }
		],
		email: [
			{ required: true, message: '请输入邮箱', trigger: 'blur' },
			{ validator: validateEmail, trigger: 'blur' }
		],
		degree: [{ required: true, message: '请选择学历', trigger: 'blur' }],
		marital_status: [{ required: true, message: '请选择婚姻状态', trigger: 'blur' }],
		family_address: [{ required: true, message: '请输入家庭住址', trigger: 'blur' }],
		school: [{ required: true, message: '请输入毕业院校', trigger: 'blur' }],
		password2: [{ validator: validatePassWord, trigger: 'blur' }],
		pic_w: [{ required: true, message: '请选择个人微信二维码', trigger: 'blur' }],
		pic_t: [{ required: true, message: '请选择APP推广码', trigger: 'blur' }]
	}
	return {
		rules,
		formProps,
		sexList,
		showPassword
	}
}
